import { render } from "./HR.vue?vue&type=template&id=c64e0ada&scoped=true"
import script from "../js/hr.js?vue&type=script&lang=js"
export * from "../js/hr.js?vue&type=script&lang=js"

import "./HR.vue?vue&type=style&index=0&id=c64e0ada&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64e0ada"]])

export default __exports__